(() => {
  const selectedType = () => {
    const active = document.querySelector('.ll-fb-box__switch-btn.is-active');
    return (active && active.getAttribute('data-ll-box-type')) || 'flavoured';
  };

  const applyType = (type) => {
    const next = type === 'decaf' ? 'decaf' : 'flavoured';
    document.documentElement.setAttribute('data-ll-fb-starter-type', next);
    document.querySelectorAll('.ll-fb-box__switch-btn').forEach((btn) => {
      const on = btn.getAttribute('data-ll-box-type') === next;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    document.querySelectorAll('.ll-fb-box__media img').forEach((img) => {
      const src = next === 'decaf' ? img.getAttribute('data-decaf-src') : img.getAttribute('data-caf-src');
      if (src) img.src = src;
    });
    document.dispatchEvent(new CustomEvent('ll-fb-starter-type', { detail: next }));
  };

  document.addEventListener('click', (event) => {
    const btn = event.target.closest('.ll-fb-box__switch-btn');
    if (!btn) return;
    event.preventDefault();
    applyType(btn.getAttribute('data-ll-box-type'));
  });

  applyType(selectedType());

  window.llFbStarterType = selectedType;
})();
